import "./student-courses.css";
import { Outlet } from "react-router-dom";

const StudentCourses = () => {
  return (
    <div className="student-courses">
      <Outlet />
    </div>
  );
};

export default StudentCourses;
